module.exports = __webpack_public_path__ + "img/arrow-left.6fc6100f.svg";